<script>
import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'

import Loading from '@/components/Loading.vue'
import validationFormMixin from '@/mixins/validation.mixin'
import {
  gerarBotoesTemplate,
  MAX_INVERSOR,
  MAX_RELE,
} from '@/utils/botao-acao-template'
import http from '@/utils/http'

const latitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(90(\.0{0,6})?|[1-8]?\d(\.\d{0,6})?)$/.test(value.toString())
}

const longitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(180(\.0{0,6})?|([1-9]|1[0-7])?\d(\.\d{0,6})?)$/.test(
    value.toString()
  )
}

export default {
  name: 'EquipamentoCampoTemplate',
  components: { Loading },
  mixins: [validationFormMixin, validationMixin],
  validations: {
    form: {
      equipamentoNome: {
        required,
        minLength: minLength(4),
      },
      descricao: {
        required,
      },
      latitude: {
        required,
        latitudeValidation,
      },
      longitude: {
        required,
        longitudeValidation,
      },
      numeroTelefone: {
        required,
        minLength: minLength(14),
      },
    },
  },
  data() {
    return {
      localId: null,
      form: {
        equipamentoNome: null,
        descricao: null,
        numeroTelefone: null,
        latitude: null,
        longitude: null,
        configTipo: 0,
        sensorTemplates: [],
        quantidadeRele: 0,
        quantidadeInversor: 0,
        incluirCmdAuto: false,
      },
      maxRele: MAX_RELE,
      maxInversor: MAX_INVERSOR,
      tipoSensores: null,
      sending: false,
      template: 'N/A',
      equipamentoTemplates: [],
    }
  },
  computed: {
    comandosPreview() {
      return gerarBotoesTemplate({
        quantidadeRele: this.form.quantidadeRele,
        quantidadeInversor: this.form.quantidadeInversor,
        incluirCmdAuto: this.form.incluirCmdAuto,
      })
    },
  },
  mounted() {
    this.localId = this.$route.params.localId
    this.loadTipoSensores()
    this.loadEquipamentoTemplates()
  },
  methods: {
    loadEquipamentoTemplates() {
      http.get('/template-equipamento').then((response) => {
        this.equipamentoTemplates = response.templates
      })
    },
    loadTipoSensores() {
      http.get('/tiposSensores').then((response) => {
        this.tipoSensores = response.tiposSensores.map((tipo) => {
          return {
            ...tipo,
            quantidade: 0,
          }
        })

        this.tipoSensores = this.tipoSensores.filter(
          (s) => s.prefixoIntegracao !== null && s.prefixoIntegracao !== ''
        )
      })
    },
    handleSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.sending = true

      const quantidadeRele = this.form.quantidadeRele
      const quantidadeInversor = this.form.quantidadeInversor

      http
        .post('/equipamento/template', {
          ...this.form,
          localId: this.localId,
          configTipo:
            quantidadeRele > 0 || quantidadeInversor > 0
              ? 1
              : this.form.configTipo,
          quantidadeRele,
          quantidadeInversor,
          incluirCmdAuto: this.form.incluirCmdAuto,
          sensorTemplates: this.tipoSensores
            .filter((s) => s.quantidade > 0)
            .map((e) => ({
              tipoId: e.id,
              quantidade: e.quantidade,
            })),
        })
        .then((e) => {
          this.$router.push({
            name: 'EquipamentoCampoEditar',
            params: { equipamentoId: e },
          })
        })
        .finally(() => {
          this.sending = false
        })
    },
    addQuantidadeSensor(id, add) {
      const sensor = this.tipoSensores.find((s) => s.id === id)

      if (!sensor) {
        return
      }

      if (sensor.quantidade + add < 0) {
        return
      }

      this.template = 'N/A'

      sensor.quantidade += add
    },
    onSelected(value) {
      if (value === 'N/A') {
        return
      }

      const equipamentoTemplate = this.equipamentoTemplates.find(
        (t) => t.id === value
      )

      Object.entries(equipamentoTemplate.template).forEach(([key, count]) => {
        this.setQuantidadeSensor(key, count)
      })
    },
    setQuantidadeSensor(id, quantidade) {
      const sensor = this.tipoSensores.find((s) => s.id === id)

      if (!sensor) {
        return
      }

      sensor.quantidade = quantidade
    },
    addQuantidadeComando(campo, add, max) {
      const atual = this.form[campo]
      const proximo = atual + add

      if (proximo < 0 || proximo > max) {
        return
      }

      this.form[campo] = proximo
    },
  },
}
</script>

<template>
  <div>
    <div class="row" style="align-items: baseline">
      <div class="col-8">
        <div class="md-title">Cadastrar Equipamento por Template</div>
      </div>
      <div class="col-1">
        <div class="md-title">Sensores</div>
      </div>
      <div class="col-3">
        <div style="display: flex">
          <div>
            <md-field>
              <label for="template">Template</label>
              <md-select
                id="template"
                v-model="template"
                name="template"
                @md-selected="onSelected"
              >
                <md-option value="N/A"> N/A </md-option>

                <md-option
                  v-for="template in equipamentoTemplates"
                  :key="template.id"
                  :value="template.id"
                >
                  {{ template.descricao }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form action="" class="md-layout" @submit.prevent="handleSubmit">
          <div class="md-layout-item">
            <md-card-content v-if="!sending">
              <div class="md-layout-item md-small-size-100">
                <md-field :class="getValidationClass('equipamentoNome')">
                  <label :for="`equipamentoNome${_uid}`">
                    Equipamento Nome
                  </label>
                  <md-input
                    v-model.trim="form.equipamentoNome"
                    name="equipamentoNome"
                    :for="`equipamentoNome${_uid}`"
                    :disabled="sending"
                  />
                  <span
                    v-if="!$v.form.equipamentoNome.required"
                    class="md-error"
                    >Usuário é obrigatório</span
                  >
                  <span
                    v-else-if="!$v.form.equipamentoNome.minLength"
                    class="md-error"
                    >Minimo de 4 letras</span
                  >
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100">
                <md-field :class="getValidationClass('descricao')">
                  <label :for="`${_uid}descricao`">Descrição</label>
                  <md-input
                    :id="`${_uid}descricao`"
                    v-model.trim="form.descricao"
                    name="descricao"
                    :disabled="sending"
                  />
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100">
                <md-field :class="getValidationClass('numeroTelefone')">
                  <label :for="`${_uid}numeroTelefone`"
                    >Numero de telefone</label
                  >
                  <md-input
                    :id="`${_uid}numeroTelefone`"
                    v-model.trim="form.numeroTelefone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    name="numeroTelefone"
                    :disabled="sending"
                  />
                  <span v-if="!$v.form.numeroTelefone.required" class="md-error"
                    >Telefone é obrigatório</span
                  >
                  <span
                    v-if="!$v.form.numeroTelefone.minLength"
                    class="md-error"
                    >Telefone inválido</span
                  >
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100">
                <md-field :class="getValidationClass('latitude')">
                  <label for="latitude">Latitude (graus decimais)</label>
                  <md-input
                    id="latitude"
                    v-model.number="form.latitude"
                    v-coordinate-decimals
                    name="latitude"
                    type="number"
                    step="0.000001"
                    :disabled="sending"
                  />
                  <span v-if="!$v.form.latitude.required" class="md-error">
                    Latitude é obrigatória
                  </span>
                  <span
                    v-if="!$v.form.latitude.latitudeValidation"
                    class="md-error"
                  >
                    Latitude inválida
                  </span>
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100">
                <md-field :class="getValidationClass('longitude')">
                  <label for="longitude">Longitude (graus decimais)</label>
                  <md-input
                    id="longitude"
                    v-model.number="form.longitude"
                    v-coordinate-decimals
                    name="longitude"
                    type="number"
                    step="0.000001"
                    :disabled="sending"
                  />
                  <span v-if="!$v.form.longitude.required" class="md-error">
                    Longitude é obrigatória
                  </span>
                  <span
                    v-if="!$v.form.longitude.longitudeValidation"
                    class="md-error"
                  >
                    Longitude inválida
                  </span>
                </md-field>
              </div>
            </md-card-content>

            <md-progress-bar v-if="sending" md-mode="indeterminate" />

            <md-card-actions>
              <md-button class="md-accent" @click="() => $router.back()">
                Voltar
              </md-button>
              <md-button type="submit" class="md-primary" :disabled="sending">
                Salvar
              </md-button>
            </md-card-actions>
          </div>
        </form>
      </div>
      <div class="col-4">
        <div class="md-subheading mb-2">Comandos</div>
        <div class="md-layout" style="text-align: center">
          <div class="md-layout-item md-size-5">
            <md-button
              class="md-icon-button md-primary"
              :disabled="form.quantidadeRele <= 0"
              @click="() => addQuantidadeComando('quantidadeRele', -1, maxRele)"
            >
              <md-icon>remove</md-icon>
            </md-button>
          </div>
          <div class="md-layout-item md-size-5 mt-2" style="text-align: right">
            <span class="md-subheading">{{ form.quantidadeRele }}</span>
          </div>
          <div class="md-layout-item md-size-5">
            <md-button
              class="md-icon-button md-primary"
              :disabled="form.quantidadeRele >= maxRele"
              @click="() => addQuantidadeComando('quantidadeRele', 1, maxRele)"
            >
              <md-icon>add</md-icon>
            </md-button>
          </div>
          <div
            class="md-layout-item mt-2 pl-4 md-size-40"
            style="text-align: left"
          >
            Relé
          </div>
        </div>

        <div class="md-layout" style="text-align: center">
          <div class="md-layout-item md-size-5">
            <md-button
              class="md-icon-button md-primary"
              :disabled="form.quantidadeInversor <= 0"
              @click="
                () =>
                  addQuantidadeComando('quantidadeInversor', -1, maxInversor)
              "
            >
              <md-icon>remove</md-icon>
            </md-button>
          </div>
          <div class="md-layout-item md-size-5 mt-2" style="text-align: right">
            <span class="md-subheading">{{ form.quantidadeInversor }}</span>
          </div>
          <div class="md-layout-item md-size-5">
            <md-button
              class="md-icon-button md-primary"
              :disabled="form.quantidadeInversor >= maxInversor"
              @click="
                () => addQuantidadeComando('quantidadeInversor', 1, maxInversor)
              "
            >
              <md-icon>add</md-icon>
            </md-button>
          </div>
          <div
            class="md-layout-item mt-2 pl-4 md-size-40"
            style="text-align: left"
          >
            Inversor de frequência
          </div>
        </div>

        <div class="mt-2 mb-3">
          <md-switch v-model="form.incluirCmdAuto"> Comandos AUTO </md-switch>
        </div>

        <md-divider class="mb-3" />

        <loading :loading="!tipoSensores" />
        <div v-if="!!tipoSensores">
          <div
            v-for="sensor in tipoSensores"
            :key="sensor.id"
            class="md-layout"
            style="text-align: center"
          >
            <div class="md-layout-item md-size-5">
              <md-button
                class="md-icon-button md-primary"
                @click="() => addQuantidadeSensor(sensor.id, -1)"
              >
                <md-icon>remove</md-icon>
              </md-button>
            </div>

            <div
              class="md-layout-item md-size-5 mt-2"
              style="text-align: right"
            >
              <span class="md-subheading">
                {{ sensor.quantidade }}
              </span>
            </div>

            <div class="md-layout-item md-size-5">
              <md-button
                class="md-icon-button md-primary"
                @click="() => addQuantidadeSensor(sensor.id, 1)"
              >
                <md-icon>add</md-icon>
              </md-button>
            </div>

            <div
              class="md-layout-item mt-2 pl-4 md-size-40"
              style="text-align: left"
            >
              {{ sensor.tipo }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="comandosPreview.length" class="row mt-3 pl-2">
      <div class="md-title">Ações</div>
      <div class="inner_badge ml-1">{{ comandosPreview.length }}</div>
    </div>
    <div v-if="comandosPreview.length" class="row mt-2">
      <div
        v-for="comando in comandosPreview"
        :key="comando.acao"
        class="col-sm-12 col-md-4 mt-1"
      >
        <div class="card-show">
          <div class="row" style="align-items: center">
            <div class="col-1">
              <md-icon
                class="md-primary"
                :style="{
                  ['background-color']: comando.cor,
                  ['border-radius']: '2px',
                  ['min-height']: '2vh',
                  ['min-width']: '2vh',
                }"
              />
            </div>
            <div class="col">
              <p class="md-title mt-1 mb-1">{{ comando.nomeExibicao }}</p>
            </div>
          </div>
          <p
            class="md-caption mb-0"
            style="
              font-size: 0.9rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            "
          >
            {{ comando.acao }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.card-show {
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.inner_badge {
  text-align: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  font-size: 0.9rem;
  background-color: #1b1f26b8;
  color: white;
  font-weight: bold;
  border-radius: 20px;
}
</style>
